import keyMirror from '../../utils/keyMirror';
import api from '../../services/api/documentService';

export const actionTypes = keyMirror({
    GET_DOCUMENTS: 'GET_DOCUMENTS',
    GET_DOCUMENT: 'GET_DOCUMENT',
    GET_DOCUMENT_CONTENT_MAPPING: 'GET_DOCUMENT_CONTENT_MAPPING',
    SET_TYPE_SUBTYPE_MAP: 'SET_TYPE_SUBTYPE_MAP',
    SET_SUBTYPES: 'SET_SUBTYPES',
    CREATE_DOCUMENT: 'CREATE_DOCUMENT',
    UPDATE_DOCUMENT: 'UPDATE_DOCUMENT',
    RESET_DOCUMENT: 'RESET_DOCUMENT',
}, 'Document');

export const getDocumentsByCompanyId = (id) => dispatch => {
    api.GetCompanyDocuments(id).then(response => {
        const { data } = response;
        dispatch({
            type: actionTypes.GET_DOCUMENTS,
            payload: data
        });
    })
}

export const getDocumentById = (id, docId, successHandler, errorHandler) => dispatch => {
    api.GetCompanyDocumentById(id, docId).then(response => {
        const { data } = response;
        dispatch({
            type: actionTypes.GET_DOCUMENT,
            payload: data,
        });
        successHandler();
    }).catch((error) => {
        errorHandler(error?.response?.data?.message || error?.message || error);
    });
}

export const getDocumentContentMapping = () => dispatch => {
    api.GetDocumentContentMapping().then(response => {
        const { data } = response;
        dispatch({
            type: actionTypes.GET_DOCUMENT_CONTENT_MAPPING,
            payload: data,
        });
    })
}

export const setTypeSubTypeMapping = (data) => dispatch => {
    dispatch({
        type: actionTypes.SET_TYPE_SUBTYPE_MAP,
        payload: data
    })
}

export const setSubTypes = (data) => dispatch => {
    dispatch({
        type: actionTypes.SET_SUBTYPES,
        payload: data
    })
}

// Action Creators
export const createDocument = (docData, onUpload, successHandler, errorHandler) => dispatch => {
    api.CreateDocument(docData, onUpload).then(() => {

        dispatch({
            type: actionTypes.CREATE_DOCUMENT,
        });
        successHandler();

    }).catch((error) => {
        errorHandler(error?.response?.data?.message || error?.message || error);
    });
}

export const updateDocument = (docData, onUpload, successHandler, errorHandler) => dispatch => {
    api.UpdateDocument(docData, onUpload).then(() => {
        dispatch({
            type: actionTypes.UPDATE_DOCUMENT,
        })
        successHandler();
    }).catch((error) => {
        errorHandler(error?.response?.data?.message || error?.message || error);
    });
}

export const resetDocument = () => dispatch => {
    dispatch({
        type: actionTypes.RESET_DOCUMENT,
    })
}


// Reducer
export const initialState = {
    documents: null,
    documentContentMap: null,
    typeSubTypeMap: null,
    subTypes: null,
    currentDocument: null,
}


export default function documentReducer(state = initialState, { type, payload }) {
    switch (type) {
        case actionTypes.GET_DOCUMENTS:
            return {
                ...state,
                documents: [...payload]
            }
        case actionTypes.GET_DOCUMENT:
            return {
                ...state,
                currentDocument: { ...payload }
            }
        case actionTypes.GET_DOCUMENT_CONTENT_MAPPING:
            return {
                ...state,
                documentContentMap: [...payload]
            }
        case actionTypes.SET_TYPE_SUBTYPE_MAP:
            return {
                ...state,
                typeSubTypeMap: { ...payload }
            }
        case actionTypes.SET_SUBTYPES:
            return {
                ...state,
                subTypes: [...payload]
            }
        case actionTypes.RESET_DOCUMENT:
            return {
                ...state,
                currentDocument: initialState.currentDocument,
            }

        default:
            return state;
    }
}
